<template>
    <div class="pb-2">
        <div class="card-header d-flex justify-content-between align-items-center">
            <span class="card-header__title">{{ $t('AppVehicleInfoVehiclesGroup.Frente de trabalho') }}</span>
            <app-button type="success" class="card-header__save" @handleClick="handleSave">
                <i class="pi pi-save"/>
            </app-button>
        </div>
        <div class="card-body d-flex align-items-center justify-content-center">
            <Dropdown v-model="vehiclesGroupSelected" dataKey="id" :options="organizationVehiclesGroups" filter
                         optionLabel="name" showClear style="width: 100%"/>
        </div>
        <Dialog :visible.sync="showSaveVehiclesGroup" modal :contentStyle="{width: '450px'}">
            <template #header>
                <div style="font-size: larger; font-weight: bold" class="pl-3">
                    <span>{{ $t('AppVehicleInfoVehiclesGroup.Associar à frente de trabalho?') }}</span>
                </div>
            </template>
            <div class="pl-3"/>
            <template #footer>
                <Button :label="$t('AppVehicleInfoVehiclesGroup.Cancelar')" @click="showSaveVehiclesGroup = false"
                        class="p-button-secondary"/>
                <Button :label="$t('AppVehicleInfoVehiclesGroup.Associar')" @click="saveVehiclesGroup" class="p-button-info"/>
            </template>
        </Dialog>
    </div>
</template>

<script>

import Dialog from "primevue/dialog";
import Button from "primevue/button";
import Dropdown from "primevue/dropdown";
import AppButton from "@/components/common/AppButton.vue";

import dateHourFormat from "@/mixins/DateMixin";

export default {
    mixins: [dateHourFormat],
    data() {
        return {
            showSaveVehiclesGroup: false,
            vehiclesGroupSelected: null
        }
    },
    props: {
        vehicle: {
            type: Object,
            required: true
        },
        vehicleVehiclesGroup: {
            type: Object
        },
        organizationVehiclesGroups: {
            type: Array,
            required: true
        }
    },
    methods: {
        handleSave() {
            this.showSaveVehiclesGroup = true;
        },
        saveVehiclesGroup() {
            this.showSaveVehiclesGroup = false;
            this.$emit('associateVehiclesGroup', this.vehiclesGroupSelected);
        }
    },
    watch: {
        vehicleVehiclesGroup: function () {
            this.vehiclesGroupSelected = this.vehicleVehiclesGroup ?? null;
        }
    },
    components: {Dropdown, Button, Dialog, AppButton}
}
</script>

<style scoped>

.card-header {
    padding: 14px 18px;
    border-bottom: 1px solid #f0f2f3;
}

.card-header__title {
    font-size: 1.05rem;
    font-weight: 600;
    color: #3a3a3a;
}

.card-header__save {
    border-radius: 8px;
    padding: 6px 12px;
}

.card-header__save .pi {
    font-size: 13px;
    padding-right: 0;
}

.card-body {
    padding: 16px 18px;
}

</style>
